'use client'

import ArrowUp from '@/assets/icons/arrow-up.svg'
import { ROUTES } from '@/core/constants/routes'
import { capitalizeFirstLetter } from '@/core/lib/utils/capitalize-first-letter'
import { CitySlugModel } from '@/features/cities/types/models/city-slug.model'
import { Link } from '@/i18n/navigation'
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from '@heroui/dropdown'
import { NavbarItem } from '@heroui/navbar'

import { useTranslations } from 'next-intl'
import { use } from 'react'

type Props = {
  citySlugs: Promise<CitySlugModel[]>
}

export const CitiesDropdown: React.FC<Props> = ({
  citySlugs: citySlugsPromise,
}) => {
  const t = useTranslations()
  const citySlugs = use(citySlugsPromise)
  const options = citySlugs.map(({ slug, id }) => ({
    slug,
    id,
  }))

  return (
    <Dropdown className={'w-fit min-w-fit'}>
      <NavbarItem>
        <DropdownTrigger>
          <button className='flex w-fit cursor-pointer items-center gap-1 p-0 text-lg font-medium text-inherit'>
            {t('links.cities')}
            <ArrowUp className='mt-1 rotate-180' />
          </button>
        </DropdownTrigger>
      </NavbarItem>
      <DropdownMenu
        aria-label={t('ariaLabels.cities')}
        classNames={{
          base: 'max-h-52 overflow-y-auto',
        }}
        itemClasses={{
          base: 'gap-4 ',
        }}
      >
        <>
          {options.map(city => (
            <DropdownItem
              key={city.id}
              aria-label={`${t('ariaLabels.detailsAbout')} ${city.slug}`}
              className='py-0'
            >
              <Link
                href={ROUTES.city(city.slug)}
                className='block h-full w-full py-1.5'
                prefetch={false}
              >
                {capitalizeFirstLetter(city.slug?.split('-')?.[0] || '')}
              </Link>
            </DropdownItem>
          ))}
        </>
      </DropdownMenu>
    </Dropdown>
  )
}
